// Main entry point
export * from './routes';
export { default } from './routes';

export { TraderverseTestFile } from './TraderverseTestFile';
export type {
  WidgetConfig,
  CandlestickChartConfig,
  MarketData,
  WidgetEventType,
  WidgetEvent,
  WidgetEventHandler,
} from './types';
export { pickCandlestickExportConfig } from './helpers';

// Host auth (SEC-40): the SDK holds no credential; the host passes a token provider.
import { configureWidgetAuth, resetWidgetAuth } from './auth';
export { configureWidgetAuth, resetWidgetAuth, resolveApiOrigin, gatewayBase } from './auth';
export type { WidgetAuthOptions, AccessTokenProvider } from './auth';
if (typeof window !== 'undefined') {
  // Script-tag hosts: window.TraderverseWidgetAuth.configure({ getAccessToken, apiOrigin })
  (window as unknown as { TraderverseWidgetAuth: unknown }).TraderverseWidgetAuth = {
    configure: configureWidgetAuth,
    reset: resetWidgetAuth,
  };
}

export {
  DEFAULT_NATS_URL,
  DEFAULT_STREAM_NAME,
  priceSubject,
  lastPriceFromKline,
  connectNatsJetStream,
  consumePriceUpdates,
  drainNats,
  acquireGlobalNatsJetStream,
  releaseGlobalNatsJetStream,
  subscribeSymbol,
  subscribeLivePriceKline,
  getDevNatsToken,
  resolveNatsAuthToken,
} from './nats';
export type {
  PriceKlinePayload,
  NatsLiveHandle,
  SubscribeSymbolOptions,
  SubscribeLivePriceKlineOptions,
  ResolveNatsAuthTokenParams,
} from './nats';

export { WidgetsList } from './widgets';
